module.exports = __webpack_public_path__ + "static/img/h1-2.95b2667.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd116/h1-2.png
// module id = dneX
// module chunks = 1